module.exports = __webpack_public_path__ + "img/mascot.2c9fa2a1.svg";